import { HttpService } from "@/core";
export const updateStatusOffPayment = () => {
  const api = ( data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url:`/common_api/fundStatusChange`,
      data
    });
  return  HttpService.usePagination<any>(api);
};
